// extracted by mini-css-extract-plugin
export default {"socials":"ContactInfo_socials__Dw5UI","wrapper":"ContactInfo_wrapper__f37xi"};